<template>
  <v-container class="fill-height">
    <v-row align="center" justify="center">
      <v-progress-circular :size="100" :width="5" color="primary" indeterminate>
        <span class="secondary--text">Loading</span>
      </v-progress-circular>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "UserBilling",
  data() {
    return {};
  },
  created() {
    this.load();
  },
  methods: {
    async load() {
      try {
        let self_serve_portal = await this.$api(`/user/billing`);
        window.open(self_serve_portal.url);
      } catch (ex) {
        alert(ex.error);
      }
    }
  }
};
</script>

<style>
</style>